import { ClassAttributes, InputHTMLAttributes } from "react"
import styles from "./Select.module.css";

export const Select = (props: JSX.IntrinsicAttributes & ClassAttributes<HTMLSelectElement> & InputHTMLAttributes<HTMLSelectElement>) => {
    return <select className={styles.select} {...props} />
}